import queryString from 'query-string';

import { locationProvider } from '@/providers/locationProvider';
import { ActivityKindEnum, ClientRequestModel } from '@/types';

export const getClientRequestListingsUrl = async (request: ClientRequestModel) => {
  const locationName = request.nameEn || request.addressEn?.split(',').pop()?.trim();
  let resolvedLocationId = request.locationId;

  if (!resolvedLocationId && locationName) {
    try {
      const { ok, data } = await locationProvider.getAds({ name: locationName });
      if (ok && data?.items?.length) {
        const latitude = Number(request.coordinatesLat);
        const longitude = Number(request.coordinatesLong);
        const locationByCoordinates =
          Number.isFinite(latitude) && Number.isFinite(longitude)
            ? data.items.find(
                (location) =>
                  Math.abs(location.latitude - latitude) < 0.000001 &&
                  Math.abs(location.longitude - longitude) < 0.000001
              )
            : undefined;
        const normalizedLocationName = locationName.toLowerCase();
        const locationByName = data.items.find(
          (location) => location[location.kind]?.trim().toLowerCase() === normalizedLocationName
        );
        resolvedLocationId = (locationByCoordinates ?? locationByName ?? data.items[0])?.id;
      }
    } catch {
      // Keep the card's coordinate fallback when location lookup is unavailable.
    }
  }

  const shouldUseLocationId = !!resolvedLocationId;
  const paramsString = queryString.stringify(
    {
      addressParamAddress: request.addressEn,
      addressParamLat: shouldUseLocationId ? undefined : request.coordinatesLat,
      addressParamLong: shouldUseLocationId ? undefined : request.coordinatesLong,
      addressParamName: locationName,
      addressParamPlaceId: shouldUseLocationId ? undefined : request.placeId,
      areaMax: request.conversion.convertedAreaTo,
      areaMin: request.conversion.convertedAreaFrom,
      baths: request.baths,
      beds: request.bedsArr,
      locationId: resolvedLocationId,
      page: 1,
      priceMax: request.conversion.convertedPriceTo,
      priceMin: request.conversion.convertedPriceFrom,
      propertyKind: request.propertyKind,
      rentFrequency: request.period,
    },
    { skipEmptyString: true, skipNull: true }
  );
  const route = request.typeOfActivity === ActivityKindEnum.Rent ? '/ads/rent' : '/';
  return `${route}?${paramsString}`;
};
